import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  blackColor,
  greyColor060,
  greyShade08,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import OrderSaleTableSection from "./Sections/OrderSaleTableSection";
import { getTopSellingProductsData } from "../../reducers/orderReports/orderReportsSlice";
import { addThousandsSeparator } from "../../utils/helper";
import moment from "moment";
import {
  getOrderReportAvgData,
  getOrderReportByCityData,
  getOrderReportByTypeYearData,
} from "../../reducers/orderSummary/orderSummarySlice";
import SalesByYearChart from "./Sections/SalesByYearChart";
import {
  getAllBusinessCustomersData,
  getAllBusinessCustomersDataMB,
} from "../../reducers/crmcustomerdata/customerSlice";
import SalesByDaysChart from "./Sections/SalesByDaysChart";
import EmptyCard from "../../components/Alerts/EmptyCard";
import { getBranchInfoAPI } from "../../service/api_calls/multiBranchCatalog/multiBranchCatalogAPIs";
import {
  getOrderReportAvgDataMB,
  getOrderReportByCityDataMB,
  getOrderReportByDaysDataMultiBranch,
  getSaleAmtDataByYearMultiBranch,
  getSummaryMultiBranch,
  getTableSaleAmtDataByMonthMultiBranch,
} from "../../reducers/multiBranchOrderAnalysis/multiBranchOrderSummarySlice";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import SalesByAreaSection from "./Sections/SalesByAreaSection";
import MultiBranchInfo from "./Sections/MultiBranchInfo";
import { getMainBranchInfoApi } from "../../service/api_calls/dashboard/dashboardApi";
import OrderSaleAvgSection from "./Sections/OrderSaleAvgSection";
import TopCustomerSection from "../OrderSummaryReport/Sections/TopCustomerSection";

function MultiBranchOrderSummaryReportContent() {
  const [activeTab, setActiveTab] = useState("summary");

  const businessId = sessionStorage.getItem("selectedBusinessId");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [masterBranchInfo, setMasterBranchInfo] = useState(null);
  const [branchInfo, setBranchInfo] = useState(null);
  const [allBranchIds, setAllBranchIds] = useState(null);
  const [allBusinessData, setAllBusinessData] = useState([]);

  const { activeBusinessInfo } = useSelector((state) => state.businessPreview);

  const {
    summaryCountMultiBranch,
    summaryCountLoader,
    orderSaleAmtYearDataMultiBranch,
    orderReportByDaysMB,
    orderSaleAmtTableMonthDataMB,
    orderReportByCityMB,
    orderReportAvgMB,
  } = useSelector((state) => state.multiBranchOrderSummary);

  const {
    businessCustomersMB,
    businessCustomersMBPageNo,
    businessCustomerMBLoader,
  } = useSelector((state) => state.businessCustomers);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const businessUrl = sessionStorage.getItem("costboWEBURL");

    if (tab === "details") navigate(`/${businessUrl}/multiBranchOrderReports`);
    else if (tab === "summary")
      navigate(`/${businessUrl}/multiBranchOrderReportsSummary`);
  };

  function prepareDateRangePayload(selectedDateRange) {
    const today = moment();
    let fromDate, toDate;

    switch (selectedDateRange) {
      case "15 days":
        fromDate = moment().subtract(13, "days").startOf("day").valueOf();
        // fromDate = moment().subtract(1, "month").startOf("month");
        toDate = today.endOf("day");
        break;

      // case "30 days":
      //   fromDate = moment().subtract(1, "month").startOf("month");
      //   toDate = today.endOf("day");
      //   break;

      case "3 months":
        fromDate = moment().subtract(2, "months").startOf("month");
        toDate = today.endOf("month");
        break;

      case "6 months":
        fromDate = moment().subtract(5, "months").startOf("month");
        toDate = today.endOf("month");
        break;

      default:
        // Default to the entire current year if nothing is selected
        fromDate = moment().startOf("year");
        toDate = moment().endOf("year");
    }

    return {
      from: fromDate.valueOf(),
      to: toDate.valueOf(),
    };
  }

  const handleFilter = (values) => {
    console.log("search params", values);
    let payload = null;

    let mainBranchId = businessId;
    if (!activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId) {
      mainBranchId = activeBusinessInfo?.mainBranchId || "";
    }

    const branchIds = branchInfo?.branchInfo
      ?.map((item) => item?.branchId)
      ?.join(",");

    if (values?.type === "year") {
      payload = {
        params: {
          businessIds: branchIds + `,${mainBranchId}`,
          from: moment(`${values?.year}-01-01`).startOf("day").valueOf(),
          to: moment(`${values?.year}-12-31`).endOf("day").valueOf(),
          groupBy: "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: values?.type,
      };
    } else {
      payload = {
        params: {
          businessIds: branchIds + `,${mainBranchId}`,
          ...prepareDateRangePayload(values.dateRange),
          groupBy: values.dateRange === "15 days" ? "day" : "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: values?.type,
      };
    }
    dispatch(getTableSaleAmtDataByMonthMultiBranch(payload));
  };

  const getBranchDetails = async () => {
    let mainBranchId = businessId;
    let masterBranchData = activeBusinessInfo;
    let masterBranchName = activeBusinessInfo?.name || "";

    if (!activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId) {
      mainBranchId = activeBusinessInfo?.mainBranchId || "";
      masterBranchData = await getMainBranchInfoApi(businessId);
      masterBranchName = masterBranchData?.details?.masterBranchName;
    }

    setMasterBranchInfo(masterBranchData?.details || activeBusinessInfo);

    const branchListData = await getBranchInfoAPI(mainBranchId);

    setBranchInfo(branchListData?.details || null);

    const branchIds = branchListData?.details?.branchInfo
      ?.map((item) => item?.branchId)
      ?.join(",");

    setAllBranchIds(branchIds + `,${mainBranchId}`);

    const subBranchInfo = branchListData?.details?.branchInfo || [];
    const allSubBranchInfo = [
      ...subBranchInfo,
      {
        branchId: mainBranchId,
        businessName: masterBranchName,
      },
    ];
    setAllBusinessData(allSubBranchInfo || []);

    if (!summaryCountMultiBranch) {
      dispatch(
        getSummaryMultiBranch({
          branchIds: branchIds + `,${mainBranchId}`,
          businessId,
        })
      );
    }
  };

  const getBrandNameById = (id) => {
    const brandDetails = allBusinessData?.find((item) => item?.branchId == id);
    return brandDetails?.businessName || "-";
  };

  useEffect(() => {
    getBranchDetails();

    return () => {};
  }, []);

  useEffect(() => {
    if (
      !summaryCountMultiBranch ||
      summaryCountMultiBranch?.totalOrders === 0 ||
      !branchInfo
    )
      return;

    const currentYear = moment().year();

    let mainBranchId = businessId;
    if (!activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId) {
      mainBranchId = activeBusinessInfo?.mainBranchId || "";
    }

    const branchIds = branchInfo?.branchInfo
      ?.map((item) => item?.branchId)
      ?.join(",");

    dispatch(getTopSellingProductsData(businessId));
    dispatch(getOrderReportByCityDataMB(branchIds + `,${mainBranchId}`));
    dispatch(getOrderReportByTypeYearData(businessId));
    dispatch(getOrderReportAvgDataMB(branchIds + `,${mainBranchId}`));
    dispatch(
      getTableSaleAmtDataByMonthMultiBranch({
        params: {
          businessIds: branchIds + `,${mainBranchId}`,
          from: moment(`${currentYear}-01-01`).startOf("day").valueOf(),
          to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
          groupBy: "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: "year",
      })
    );

    dispatch(
      getAllBusinessCustomersDataMB({
        businessId: branchIds + `,${mainBranchId}`,
        pageNo: 1,
      })
    );

    dispatch(
      getSaleAmtDataByYearMultiBranch({
        params: {
          businessIds: branchIds + `,${mainBranchId}`,
          from: moment(`2022-01-01`).startOf("day").valueOf(),
          to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
          groupBy: "year",
          pageNo: "1",
          pageSize: "1",
        },
      })
    );

    dispatch(
      getOrderReportByDaysDataMultiBranch({
        params: {
          businessIds: branchIds + `,${mainBranchId}`,
          from: moment().subtract(5, "days").startOf("day").valueOf(),
          to: moment().endOf("day").valueOf(),
          groupBy: "day",
          pageNo: "1",
          pageSize: "1",
        },
      })
    );
  }, [summaryCountMultiBranch, branchInfo]);

  // useEffect(() => {
  //   if (!statsCountInfo) {
  //     dispatch(getStatsCountInfoData(businessId));
  //   }
  // }, []);

  return (
    <Box
      sx={{
        background: whiteColor,
        borderRadius: "12px",
        padding: "15px",
        mt: "20px",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box
          display="inline-flex"
          sx={{
            borderBottom: "0px solid #e7e8eb",
            borderRadius: "7px",
            background: "#f1f4f7",
            padding: "8px 12px",
            gap: 2,
          }}
        >
          <Button
            onClick={() => handleTabChange("summary")}
            sx={{
              height: "35px",
              color: activeTab === "summary" ? whiteColor : blackColor,
              background: activeTab === "summary" ? "#3f53d8" : "transparent",
              borderRadius: "5px",
              fontSize: "13px",
              fontWeight: 600,
              px: "15px",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#3f53d8",
                color: whiteColor,
              },
            }}
          >
            Multi Branch Order Summary
          </Button>
          <Button
            onClick={() => handleTabChange("details")}
            sx={{
              height: "35px",
              px: "15px",
              color: blackColor,
              border: "none",
              background: "transparent",
              borderRadius: "5px",
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#3f53d8",
                color: "#ffffff",
              },
            }}
          >
            Multi Branch Order Detail Analysis
          </Button>
        </Box>
        <Typography fontSize={12} color={greyShade08}>
          Order Summary starts from 1st Jan 2022
        </Typography>
      </Box>

      <Box mt={2}>
        <MultiBranchInfo
          masterBranchInfo={masterBranchInfo}
          branchInfo={branchInfo?.branchInfo}
        />
      </Box>

      {summaryCountLoader && <ThreeDotLoader />}

      {summaryCountMultiBranch?.totalOrders === 0 && (
        <EmptyCard
          icon={"/./assets/image/order-cart-empty-1.svg"}
          iconWidth={"98px"}
          iconHeight={"85px"}
          message={"You are yet to receive your first order."}
          hideBtn
          paddingY={"30px"}
        />
      )}

      {summaryCountMultiBranch?.totalOrders > 0 && (
        <>
          <Grid container columnSpacing={4} mt={2} alignItems="stretch">
            <Grid item xs={3}>
              <Stack
                gap={"16px"}
                minHeight={"100%"}
                justifyContent={"space-between"}
              >
                <TotalOrderDetail
                  label={"Orders"}
                  value={summaryCountMultiBranch?.totalOrders || 0}
                  borderColor={`1px solid #ffdfed`}
                  bgColor={"#fff3f9"}
                  icon={
                    <ShoppingBasketOutlinedIcon
                      sx={{ fontSize: "26px", pr: 1 }}
                    />
                  }
                  iconColor={"#c94b85"}
                />
                <TotalOrderDetail
                  label={"Sales"}
                  value={`₹ ${addThousandsSeparator(
                    summaryCountMultiBranch?.totalAmount
                  )}`}
                  borderColor={`1px solid #d3f8de`}
                  bgColor={"#f1fff5"}
                  icon={
                    <AccountBalanceWalletOutlinedIcon
                      sx={{ fontSize: "26px", pr: 1 }}
                    />
                  }
                  iconColor={"#13ccac"}
                />
                <TotalOrderDetail
                  label={"Last Order Date"}
                  value={
                    summaryCountMultiBranch?.recentOrderSummary?.length > 0
                      ? moment(
                          summaryCountMultiBranch?.recentOrderSummary[0]
                            ?.orderDate
                        ).format("Do MMM YYYY")
                      : "N/A"
                  }
                  borderColor={`1px solid #e7daf5`}
                  bgColor={"#f9f3ff"}
                  icon={<CalendarMonthIcon sx={{ fontSize: "26px", pr: 1 }} />}
                  iconColor={"#894bc9"}
                />
              </Stack>
            </Grid>
            <Grid item xs={4.5}>
              <SalesByYearChart
                data={orderSaleAmtYearDataMultiBranch}
                allBranchIds={allBranchIds}
                getBrandNameById={getBrandNameById}
                masterBranchInfo={masterBranchInfo}
              />
            </Grid>

            <Grid item xs={4.5}>
              <SalesByDaysChart
                data={orderReportByDaysMB}
                allBranchIds={allBranchIds}
                getBrandNameById={getBrandNameById}
                masterBranchInfo={masterBranchInfo}
              />
            </Grid>
          </Grid>

          <OrderSaleTableSection
            data={orderSaleAmtTableMonthDataMB || []}
            handleFilter={handleFilter}
            handleClearFilter={() =>
              handleFilter({ type: "year", year: moment().year() })
            }
            allBranchIds={allBranchIds}
            getBrandNameById={getBrandNameById}
            masterBranchInfo={masterBranchInfo}
          />

          <Grid container columnSpacing={2} mt={"20px"} alignItems="stretch">
            <Grid item xs={12} md={4}>
              {/* <ProductSellingSection products={topSellingProducts} /> */}
              <OrderSaleAvgSection
                orderReportAvg={orderReportAvgMB}
                allBranchIds={allBranchIds}
                getBrandNameById={getBrandNameById}
                masterBranchInfo={masterBranchInfo}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <SalesByAreaSection
                orderReportByCity={orderReportByCityMB}
                allBranchIds={allBranchIds}
                getBrandNameById={getBrandNameById}
                masterBranchInfo={masterBranchInfo}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={"4px"} alignItems="stretch">
            <Grid item xs={12} md={12}>
              <TopCustomerSection businessCustomers={businessCustomersMB} />
            </Grid>
            {/* <Grid item xs={12} md={4}>
              <OrderSaleAvgSection
                orderReportAvg={orderReportAvgMB}
                allBranchIds={allBranchIds}
                getBrandNameById={getBrandNameById}
                masterBranchInfo={masterBranchInfo}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={4.5}>
              <OrderSaleByTypeYearSection
                orderSalesByType={orderSalesByTypeYear}
              />
            </Grid> */}
          </Grid>
        </>
      )}
    </Box>
  );
}

export default MultiBranchOrderSummaryReportContent;

function TotalOrderDetail({
  label,
  value,
  hideLabel,
  borderColor,
  bgColor,
  icon,
  iconColor,
}) {
  return (
    <Box
      sx={{
        background: bgColor,
        border: borderColor,
        width: "100%",
        display: "flex",
        alignItems: "center",
        padding: "10px 12px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          width: "35px",
          height: "35px",
          position: "relative",
          color: "#ffffff",
          background: iconColor,
          border: "1px solid #fff",
          borderRadius: "8px",
          lineHeight: "27px",
          padding: "3px 8px",
          textAlign: "center",
          marginRight: "10px",
        }}
      >
        {icon}
      </Box>
      <Box>
        {!hideLabel ? (
          <Typography
            variant="h3"
            fontSize={{ xs: 12, md: 12 }}
            color={greyColor060}
            fontWeight={400}
            lineHeight={1.5}
          >
            {label}{" "}
          </Typography>
        ) : (
          <Box sx={{ height: "22px" }} />
        )}

        <Typography
          variant="body1"
          fontSize={{ xs: 12.5, md: 14 }}
          color={blackColor}
          fontWeight={600}
        >
          {value}
        </Typography>
      </Box>
      {/* <Box
        component="img"
        maxHeight={{ xs: "29px", md: "40px" }}
        src={}
        alt="CostBo"
      /> */}
    </Box>
  );
}
